import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtendedWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 48,
	height: 49,
	viewBox: "0 0 48 49",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.23047 42.3125L24.0013 4.70837L45.7721 42.3125H2.23047ZM24.0013 36.375C24.5621 36.375 25.0321 36.1854 25.4115 35.806C25.7908 35.4267 25.9805 34.9566 25.9805 34.3959C25.9805 33.8351 25.7908 33.3651 25.4115 32.9857C25.0321 32.6064 24.5621 32.4167 24.0013 32.4167C23.4405 32.4167 22.9705 32.6064 22.5911 32.9857C22.2118 33.3651 22.0221 33.8351 22.0221 34.3959C22.0221 34.9566 22.2118 35.4267 22.5911 35.806C22.9705 36.1854 23.4405 36.375 24.0013 36.375ZM22.0221 30.4375H25.9805V20.5417H22.0221V30.4375Z",
		fill: "url(#paint0_linear_5722_37695)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_5722_37695",
		x1: 2.00136,
		y1: 42.8074,
		x2: 48.6333,
		y2: 7.71066,
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ _jsx("stop", { stopColor: "#142F95" }),
			/* @__PURE__ */ _jsx("stop", {
				offset: .5,
				stopColor: "#2563EB"
			}),
			/* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#CACBFF"
			})
		]
	}) })]
});
export default SvgExtendedWarning;
